import { Article } from 'types/content';

// TODO: find better alternative
export const isLiked = (likedArticles: Article[] | undefined, id: string) => {
  if (typeof likedArticles === 'undefined') return false;
  const a = likedArticles.filter((x) => x.id === id);
  return a.length > 0;
};
